import { Notification } from '../../../../interfaces/Notification';
import { NotificationsState } from '../../../../interfaces/NotificationsState';

export default function getSections(state: NotificationsState): {
  actionRequired: Notification[];
  unseen: Notification[];
  seen: Notification[];
} {
  const notifications = (state?.notifications?.length > 0) ? state?.notifications : [];
  const transactions = (state?.onlinetransactions?.length > 0) ? state?.onlinetransactions : [];
  const promotions = (state?.promotions?.length > 0) ? state?.promotions : [];
  return {
    actionRequired: (notifications.filter((n) => n?.type === 'actionrequired')).concat(transactions),
    unseen: promotions.concat(notifications.filter((n) => n?.type !== 'actionrequired' && n?.seen !== true)),
    seen: notifications.filter((n) => n?.type !== 'actionrequired' && n?.seen === true),
  };
}
